/******************************************
 *  Author : vsuthar
 *  Created On : Wed Aug 18 2021
 *  File : index.js
 *  ©Palo Alto Networks
 *******************************************/
import { Button, Title, Body, TruncateText, Bold, useModal } from '@panwds/react-ui'
import { CloseIcon } from '@panwds/icons'
import { getVarValue } from '../../../utils/Sparky'
import { FF_VISIBLE_TSG_ID, FF_SUPPORT_CONTACT_ENABLED } from '../../../utils/FeatureFlags'
import { LABEL_TSG_ID, LABEL_SUPPORT_CONTACT } from '../../../constants/LabelConstants'
import StringTemplate from '../../../utils/StringTemplate'
import { ROOT_NODE_ID } from '../../../../tenancy/constants/TenancyConstants'
import Link from '../../link/Link'
import SupportContactModal from '../../../../tenancy/components/licenses/SupportContactModal'
import { useCallback } from 'react'
import ZIndex from '../../zIndex/ZIndex'

const visible_tsg_id = getVarValue(FF_VISIBLE_TSG_ID, false)
const supportContactEnabled = getVarValue(FF_SUPPORT_CONTACT_ENABLED, false)

/**
 * * Header component
 * @param title
 * @param subTitle
 * @param showCloseButton
 * @param onClose
 * @param size
 * @param level
 * @param actions
 * @param className
 * @param style
 * @param selectedTreeNode
 * @returns {JSX.Element}
 * @constructor
 */
const Header = ({ title, subTitle, showCloseButton, onClose, size, level, actions, className, style, selectedTreeNode }) => {
  const supportContactModal = useModal(SupportContactModal)
  const clsName = `${className || ''} tw-flex tw-w-full tw-flex-row tw-justify-between tw-p-3`

  const onSupportContactClick = useCallback(() => {
    supportContactModal.openModal({ tenant: selectedTreeNode })
  }, [supportContactModal, selectedTreeNode])

  return (
    <ZIndex>
      <div className={clsName} style={style}>
        <div>
          <Title style={{ maxWidth: 300, display: 'flex' }} level={level} size={size}>
            <TruncateText>{title}</TruncateText>
          </Title>
          {(visible_tsg_id && selectedTreeNode && selectedTreeNode?.id !== ROOT_NODE_ID) && (
            <Bold>{StringTemplate(LABEL_TSG_ID, [selectedTreeNode?.id || ''])}</Bold>
          )}
          <Body appearance={'secondary'}>{subTitle}</Body>
          {(supportContactEnabled && selectedTreeNode && selectedTreeNode.support_contact) && (
            <Link onClick={onSupportContactClick}>{LABEL_SUPPORT_CONTACT}</Link>
          )}
        </div>
        {showCloseButton && (
          <Button
            aria-label="close"
            onClick={onClose}
            icon={<CloseIcon size='sm' />}
            appearance="tertiary-clear"
          />
        )}
        {actions}
      </div>
    </ZIndex>
  )
}
export default Header
